/* eslint-disable */
import { BehaviorSubject } from "rxjs";
import { SnackbarMessage, OptionsObject, VariantType } from "notistack";

type NoteType = {
  message: SnackbarMessage;
  options?: OptionsObject;
};

export type NotificationsType = {
  key: number;
  message: SnackbarMessage;
  options?: OptionsObject;
};

export type SnackbarParam = {
  message: string;
  variant: VariantType;
};

export class NotistackService {
  private _notifications$ = new BehaviorSubject<NotificationsType[]>([]);

  public get notifications$() {
    return this._notifications$.asObservable();
  }

  public get notifications() {
    return this._notifications$.value;
  }

  public enqueueSnackbar(note: NoteType) {
    this._notifications$.next([
      ...this.notifications,
      {
        key: new Date().getTime() + Math.random(),
        ...note,
      },
    ]);
  }

  public removeSnackbar(note: OptionsObject["key"]) {
    const index = this.notifications.findIndex((not) => not.key === note);
    if (index !== -1) {
      this.notifications.splice(index, 1);
      this._notifications$.next(this.notifications);
    }
  }

  public createSnackbar({ message, variant }: SnackbarParam) {
    this.enqueueSnackbar({
      message,
      options: {
        variant,
        action: true,
      },
    });
  }
}
